import { createServerFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { auth } from '@server/auth'

export const getAuthSession = createServerFn({ method: 'GET' }).handler(
  async () => {
    const request = getRequest()
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!request) return null
    const session = await auth.api.getSession({ headers: request.headers })
    return session
  },
)
